/**
 * Build marker — lets support tell, in one question, whether a customer's
 * browser is running the current bundle or a stale cached one.
 *
 * Ask the customer to open the browser console (F12) and read the first
 * line, or to type `__APP_BUILD__`. If the value is older than the last
 * deploy, their browser still holds the previous bundle and a hard
 * refresh (Ctrl+Shift+R) is the fix — exactly the situation behind the
 * October 2026 "Failed to fetch" reports.
 *
 * Bump BUILD_ID on every production deploy.
 */
export const BUILD_ID = '2026-10-14.1';

export function announceBuild() {
  if (typeof window === 'undefined') return;
  window.__APP_BUILD__ = BUILD_ID;
  // eslint-disable-next-line no-console
  console.info(`AUTO-REMAP file service — build ${BUILD_ID}`);
}
